<!-- 评审情况-详情 -->
<template>
  <div id="detail_reviewManagement" class="fromPage">
    <!-- 页面标题 -->
    <div class="title_page">评审情况</div>
    <!-- 基础信息 -->
    <div class="form_detail">
      <div v-for="(item, i) in keyItems" :key="i">
        <div>{{ item.title }}</div>
        <div
          v-if="item.type == 'status'"
          class="nowrap"
          :class="
            item.class_status ? item.class_status[reviewItem[item.key]] : ''
          "
        >
          {{
            item.text_status[reviewItem[item.key]]
              ? item.text_status[reviewItem[item.key]]
              : "--"
          }}
        </div>
        <div v-else-if="item.type == 'money'" class="nowrap">
          {{ `￥${common.formatNumber(reviewItem[item.key])}` }}
        </div>
        <div v-else-if="item.type == 'time'" class="nowrap">
          {{
            reviewItem[item.key]
              ? moment(reviewItem[item.key]).format("YYYY-MM-DD HH:mm:ss")
              : "--"
          }}
        </div>
        <div v-else-if="item.type == 'file'" class="nowrap">
          <div v-if="reviewItem[item.key]?.length > 0">
            <div
              v-for="(f, i) in reviewItem[item.key]"
              :key="i"
              class="file nowrap"
              @click="handleFileViewing(f)"
            >
              {{ f?.name }}
            </div>
          </div>
          <div v-else style="color: #909399">暂无附件</div>
        </div>
        <div v-else>
          {{
            reviewItem[item.key] == undefined || reviewItem[item.key] == null
              ? "--"
              : reviewItem[item.key]
          }}
        </div>
      </div>
      <!-- 参与评审企业情况列表 -->
      <div class="smallTitle">参与评审企业情况列表</div>
      <!-- 列表 -->
      <div
        class="table fitPc"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
      >
        <el-table
          :data="reviewItem.userList"
          :cell-style="cellStyle"
          :header-cell-style="headerCellStyle"
          ref="table"
          height="400"
        >
          <el-table-column
            v-for="(item, i) in tableKeys_current"
            :key="i"
            :prop="item.key"
            :label="item.title"
            :sortable="item.sortable ? 'custom' : false"
            show-overflow-tooltip
            :min-width="item.width ? item.width : ''"
            :align="item.align ?? 'center'"
          >
            <template slot-scope="props">
              <div
                v-if="item.type == 'status'"
                :class="
                  item.class_status
                    ? item.class_status[props.row[item.key]]
                    : ''
                "
              >
                {{
                  item.text_status[props.row[item.key]]
                    ? item.text_status[props.row[item.key]]
                    : "--"
                }}
              </div>
              <div v-else-if="item.type == 'money'" class="nowrap">
                {{ `￥${common.formatNumber(props.row[item.key])}` }}
              </div>
              <div v-else-if="item.type == 'time'" class="nowrap">
                {{
                  props.row[item.key]
                    ? moment(props.row[item.key]).format("YYYY-MM-DD HH:mm:ss")
                    : "--"
                }}
              </div>
              <div v-else class="nowrap">
                {{
                  props.row[item.key] == undefined ||
                  props.row[item.key] == null
                    ? "--"
                    : props.row[item.key]
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            fixed="right"
            width="300"
            align="center"
          >
            <template slot-scope="props">
              <el-button
                v-if="props.row.status == 2"
                type="text"
                @click="
                  $router.push({
                    path: '/distributionSpecialist',
                    query: {
                      id: reviewItem.id,
                      userId: props.row.userId,
                      recordId: props.row.id,
                    },
                  })
                "
              >
                分配专家</el-button
              >
              <el-button
                v-if="props.row.status > 1"
                type="text"
                @click="
                  $router.push({
                    path: '/detail_simple',
                    query: { id: props.row.id },
                  })
                "
              >
                查看详情</el-button
              >
              <el-button
                v-if="props.row.status == 1"
                type="text"
                @click="
                  (currentEnterprise = props.row), (visible_dialog = true)
                "
                >更改自评截止时间</el-button
              >
              <el-button
                v-if="props.row.status == 5"
                type="text"
                @click="openReport(props.row.selfId)"
                >查看评审报告</el-button
              >
              <el-button
                v-if="props.row.status == 5"
                type="text"
                @click="generateCertificatePDF(props.row.selfId)"
                :disabled="certificateLoading"
                >查看评审证书</el-button
              >
            </template>
          </el-table-column>
          <div slot="empty">
            <img src="../../assets/img/emptyData.png" alt="" />
          </div>
        </el-table>
      </div>
      <div class="fitIpone">
        <div class="listIpone">
          <div
            class="listIBox"
            v-for="(item, index) in reviewItem.userList"
            :key="`${index}c`"
          >
            <div class="listIponeItem">
              <div class="left">
                <div class="tiles">
                  <span
                    class="tiltBox"
                    :class="
                      [
                        'tileOrruge',
                        'tileOrruge',
                        'tileOrruge',
                        'tileRed',
                        'tileGreen',
                      ][item.status - 1]
                    "
                  ></span>
                  {{ item.userName }}
                </div>
                <div class="time">
                  目前所涉及的行业:<span>{{ item.category || "--" }}</span>
                </div>
                <div class="time">
                  评价依据:<span>{{ item.paperName || "--" }}</span>
                </div>
                <div class="time">
                  截止时间:<span v-if="item.endTime">
                    {{
                      moment(item.endTime).format("YYYY.MM.DD HH:mm:ss")
                    }}</span
                  >
                  <span v-else>暂无</span>
                </div>
              </div>
              <div class="right">
                <div
                  class="box"
                  :class="
                    [
                      'tileOrruge',
                      'tileOrruge',
                      'tileOrruge',
                      'tileRed',
                      'tileGreen',
                    ][item.status - 1]
                  "
                >
                  {{
                    [
                      "企业待自评",
                      "专家待分配",
                      "专家评审中",
                      "已截止",
                      "已完成",
                    ][item.status - 1]
                  }}
                </div>
                <template>
                  <el-button
                    v-if="item.status == 2"
                    type="text"
                    @click="
                      $router.push({
                        path: '/distributionSpecialist',
                        query: {
                          id: reviewItem.id,
                          userId: item.userId,
                          recordId: item.id,
                        },
                      })
                    "
                  >
                    分配专家</el-button
                  >
                  <el-button
                    v-if="item.status > 1"
                    type="text"
                    @click="
                      $router.push({
                        path: '/detail_simple',
                        query: { id: item.id },
                      })
                    "
                  >
                    查看详情</el-button
                  >
                  <el-button
                    v-if="item.status == 1"
                    type="text"
                    @click="(currentEnterprise = item), (visible_dialog = true)"
                    >更改截止时间</el-button
                  >
                  <el-button
                    v-if="item.status == 5"
                    type="text"
                    @click="openReport(item.selfId)"
                    >查看评审报告</el-button
                  >
                  <el-button
                    v-if="item.status == 5"
                    type="text"
                    @click="generateCertificatePDF(item.selfId)"
                    :disabled="certificateLoading"
                    >查看评审证书</el-button
                  >
                </template>

                <!-- <el-button type="text" :class="['orange', 'orange', 'blue', 'red', 'green'][item.status - 1]">{{
                  ['企业待自评', '专家待分配', '专家评审中', '已截止', '已完成'][item.status - 1]
                }}</el-button> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 表单按钮 -->
    <div class="absoluteGrop">
      <el-button
        v-if="reviewItem.status == 1"
        type="primary"
        plain
        @click="
          $router.push({
            path: '/edit_reviewManagement',
            query: { id: reviewItem.id },
          })
        "
        >修改评审设置</el-button
      >
      <el-button
        v-if="reviewItem.status == 1"
        type="danger"
        plain
        @click="finishRow()"
        >结束本次评审</el-button
      >
      <el-button plain @click="$router.go(-1)">返 回</el-button>
    </div>
    <!-- 弹窗-单企业修改自评时间 -->
    <el-dialog
      class="enterpriseEvaDialog"
      top="25vh"
      :visible.sync="visible_dialog"
      title="评审设置"
      :destroy-on-close="true"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :show-close="false"
      width="370px"
    >
      <el-row style="margin-bottom: 10px">
        <div class="theme">企业名称</div>
        <div>{{ currentEnterprise.enterprieName }}</div>
      </el-row>
      <el-date-picker
        v-model="currentEnterprise.endTime"
        type="datetime"
        placeholder="选择日期时间"
        value-format="yyyy-MM-dd HH:mm:ss"
        style="width: 100%"
      >
      </el-date-picker>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitEdit()">确 认</el-button>
        <el-button @click="visible_dialog = false">取 消</el-button>
      </div>
    </el-dialog>
    <createCardPDF ref="createCardPDF" />
  </div>
</template>
<script>
import moment from "moment";
import createCardPDF from "@/components/createCardPDF.vue";

export default {
  name: "detail_reviewManagement",
  components: {
    createCardPDF,
  },
  data() {
    return {
      loading: true,
      moment: moment,
      reviewItem: { userList: [], type: 1 },
      // 信息字段
      keyItems: [
        { title: "评审开始时间", type: "time", key: "recordStartTime" },
        {
          title: "评审类型",
          key: "type",
          type: "status",
          text_status: ["", "日常评审", "年度评审"],
          width: 150,
        },
        {
          title: "评审流程状态",
          key: "status",
          type: "status",
          text_status: ["", "评审中", "评审结束"],
          class_status: ["", "orange", "green"],
          width: 150,
        },
        { title: "参与评审企业数量", key: "count", width: 150 },
      ],
      // 列表字段合集
      tableKeys_current: [
        { title: "企业名称", key: "userName", width: 180 },
        // 1.企业待自评 2.专家待分配 3.专家评审中 4.已截止 5.已完成
        {
          title: "评审状态",
          key: "status",
          type: "status",
          text_status: [
            "",
            "企业待自评",
            "专家待分配",
            "专家评审中",
            "已截止",
            "已完成",
          ],
          class_status: ["", "orange", "orange", "orange", "red", "green"],
          width: 150,
        },
        { title: "评价依据", key: "paperName", width: 100 },
        {
          title: "本次自评完成时间",
          type: "time",
          key: "selfAssessmentTime",
          width: 150,
        },
        {
          title: "本次专家评审完成时间",
          type: "time",
          key: "expertReviewTime",
          width: 180,
        },
        { title: "目前所涉及的行业", key: "category", width: 150 },
        { title: "自评评审得分", key: "selfScore", width: 150 },
        { title: "专家评审得分", key: "appraisalResult", width: 150 },
        { title: "设备成熟度评价", key: "evaluate", width: 150 },
        { title: "星级", key: "starLevel", width: 150 },
      ],
      // 列表查询传参
      queryParam: {
        page: 1,
        limit: 10,
      },
      visible_dialog: false,
      currentEnterprise: {},
      certificateLoading: false,
    };
  },
  created() {
    this.getInfo();
  },
  computed: {
    InnerWH: function () {
      return this.$store.getters.getInnerWH;
    },
  },
  methods: {
    // 获取项目信息
    getInfo() {
      this.$axios
        .post(`${process.env.BASE_URL}api/reviewRecord/recordInfo`, {
          id: this.$route.query.id,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.reviewItem = res.data.data;
            this.loading = false;
          } else {
            console.log(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 删除
    finishRow() {
      this.$msgbox({
        title: "结束评审",
        message: `是否结束该评审？`,
        showCancelButton: true,
        distinguishCancelAndClose: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        center: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "执行中...";
            let that = this;
            this.$axios
              .post(`${process.env.BASE_URL}api/reviewRecord/deleteRecord`, {
                id: this.reviewItem.id,
              })
              .then((res) => {
                if (res.data.code == 200) {
                  that.$message({
                    message: "已结束",
                    type: "success",
                  });
                  this.getInfo();
                } else {
                  that.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
                //确认弹窗还原&关闭
                instance.confirmButtonText = "确定";
                instance.confirmButtonLoading = false;
                done();
              })
              .catch(() => {
                //确认弹窗还原&关闭
                instance.confirmButtonText = "确定";
                instance.confirmButtonLoading = false;
                done();
              });
          } else {
            //确认弹窗还原&关闭
            instance.confirmButtonText = "确定";
            instance.confirmButtonLoading = false;
            done();
          }
        },
      })
        .then((action) => {})
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
            offset: 100,
          });
        });
    },
    // 提交-设置自评时间
    submitEdit() {
      if (!this.currentEnterprise.endTime) {
        this.$message.warning("请选择自评截止时间");
      } else {
        let param = {
          endTime: this.currentEnterprise.endTime,
          userId: this.currentEnterprise.userId,
          recordId: this.reviewItem.id,
        };
        this.$axios
          .post(`${process.env.BASE_URL}api/reviewRecord/updateTime`, param)
          .then((res) => {
            if (res.data.code == 200) {
              this.$message.success("操作成功");
              this.visible_dialog = false;
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    // 查看评审报告
    openReport(selfId) {
      if (
        this.reviewItem.expertUsableNumber > 0 ||
        this.reviewItem.expertUsableNumber == null
      ) {
        window.open(`${this.report}/report.html?selfId=${selfId}`, "_blank");
        this.common.reportsNumber(1);
        this.getInfo();
      } else {
        this.$message({
          message: `使用次数不足，请联系管理员！`,
          type: "error",
          offset: 80,
        });
      }
    },

    // 生成证书PDF
    async generateCertificatePDF(selfId) {
      // 防止重复点击
      if (this.certificateLoading) return;

      try {
        this.certificateLoading = true;
        this.$message.info("正在生成证书PDF...");

        // 调用PDF生成方法并传递selfId
        await this.$refs.createCardPDF.downloadPdf(selfId);

        this.$message.success("证书生成成功！");
      } catch (error) {
        console.error("生成证书失败:", error);
        this.$message.error("生成证书失败，请重试");
      } finally {
        // 无论成功还是失败，都重置loading状态
        this.certificateLoading = false;
      }
    },

    // 预览
    handleFileViewing(file) {
      this.$refs.previewFile.openDrawer([file]);
    },
    // 列表-表头样式
    headerCellStyle(header) {
      if (
        header.column.order == "ascending" ||
        header.column.order == "descending"
      ) {
        return {
          color: "#3D7BDC",
          fontSize: "14px",
          fontWeight: 400,
          background: "#f9fafb",
        };
      } else {
        return {
          color: "#617180",
          fontSize: "14px",
          fontWeight: 400,
          background: "#f9fafb",
        };
      }
    },
    // 列表-单元格样式
    cellStyle() {
      return {
        fontSize: "14px",
        color: "#111928",
        fontWeight: 500,
        padding: "8px 0px",
        background: "#f9fafb",
      };
    },
  },
};
</script>
<style lang="less" scoped>
.form_detail {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #f9fafb;
  color: #111928;
  height: calc(100vh - 200px);
  overflow: auto;
  & > div {
    display: flex;
    width: calc(100% - 40px);
    border-bottom: 1px solid #e5e7eb;
    & > div {
      padding: 8px 15px;
    }
    & > div:first-child {
      color: #6b7280;
      width: 15vh;
      position: relative;
      flex-shrink: 0;

      &::after {
        content: "";
        position: absolute;
        right: 0px;
        width: 2px;
        height: 60%;
        top: 20%;
        font-size: 20px;
        background: #e5e7eb;
      }
    }
    .file {
      text-decoration-line: underline;
      cursor: pointer;
    }
  }
}
.smallTitle {
  padding: 8px 15px;
  color: #6b7280;
  width: 200px;
}
.enterpriseEvaDialog {
  /deep/.el-dialog__body {
    padding: 10px 20px;
  }
}
.listIpone {
  width: 100% !important;
  display: flex;
  flex-direction: column;
  // border-radius: 8px;
  // border: 1px solid #ebecf1;
  // background: #fbfdff;
  padding: 15px;
  .listIBox {
    margin-bottom: 20px;
  }
  .listIponeItem {
    display: flex;
    cursor: pointer;
    padding-bottom: 10px;
    border-bottom: 1px solid #c5c6ca;
    .left {
      .tiles {
        color: #4f5d77;
        font-size: 18px;
        font-weight: 500;
        margin-bottom: 4px;
        display: flex;
        align-items: center;
        .tiltBox {
          width: 6px;
          height: 6px;
          margin-right: 8px;
          display: inline-block;
        }
      }
      .time {
        color: rgba(79, 93, 119, 0.6);
        line-height: 25px;
        span {
          color: #4f5d77;
          font-size: 14px;
          font-weight: 500;
          letter-spacing: 0.01px;
        }
      }
    }
    .right {
      margin-left: auto;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      /deep/.el-button + .el-button {
        margin-left: 0;
      }
    }
    .box {
      width: 76px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      border-radius: 18px;
      padding: 0 6px;
      font-size: 12px;
      color: #e5e7eb;
    }
    .tileOrruge {
      background: #f68e6d;
    }
    .tileRed {
      background: #df5151;
    }
    .tileBlue {
      background: #499bde;
    }
    .tileGreen {
      background: #5b9f7b;
    }
  }
  .rowList {
    color: rgba(79, 93, 119, 0.6);
    font-size: 14px;
    line-height: 25px;
  }
}
</style>

<style lang="less" scoped>
/* PC端样式 */
@media only screen and (min-width: calc(700px + 1px)) {
  #detail_reviewManagement {
    .fitPc {
      display: flex;
    }
    .fitIpone {
      display: none;
    }
  }
}

/* 移动端样式 */
@media only screen and (max-width: 700px) {
  #detail_reviewManagement {
    .fitPc {
      display: none;
    }
    .fitIpone {
      display: block;
    }
  }
}
</style>
